<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
    <p style="position: absolute; color: White; top: 40%; left: 40%;">
      <img src='../../assets/snakes.gif' />
    </p>
  </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
              <h4 class="card-title mb-0">Snake Reports Map</h4><br>
              <p>Total records found: {{count}}</p>
               <template>
                              <b-form-group label="Please select the main filter criterias for search"
                                                style="color:rgb(243, 6, 17);font-size:8px;">
                                 <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="selected"
        :options="options"
        name="flavour-1"
      ></b-form-checkbox-group>
                                            </b-form-group>
                                        </template>
                                         <div class="row" v-cloak>
                                            <div class="col-md-3" v-if="tprd=='tprd'">
                                                <div class="form-group label-floating">
                                                    <label class="control-label">From </label>
                                                    <input type="date" class="form-control" required=""
                                                        v-model="from">
                                                </div>
                                            </div>
                                            <div class="col-md-3" v-if="tprd=='tprd'">
                                                <div class="form-group label-floating">
                                                    <label class="control-label">To </label>
                                                    <input type="date" class="form-control" required=""
                                                        v-model="to">
                                                </div>
                                            </div>
                                            <div class="col-md-3" v-if="big4=='big4'">
                                              <div class="form-group label-floating">
                                                    <label class="control-label">Select Big4 (Multiple selecton) </label>
                                                <v-select multiple v-model="big4s" :options="vbig4" ></v-select>
                                                </div>
                                            </div>
                                             <div class="col-md-3" v-if="snakesall=='snakesall'">
                                              <div class="form-group label-floating">
                                                    <label class="control-label">Select Snakes (Multiple selecton) </label>
                                                <v-select multiple v-model="snaken" :options="snakes" ></v-select>
                                                </div>
                                            </div>
                                             <div class="col-md-3" v-if="user=='user'">
                                              <div class="form-group label-floating">
                                                    <label class="control-label">Select User </label>
                                                <v-select v-model="username" :options="users" ></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group label-floating" style="padding-top:25px;">
                                                    <label class="control-label"></label>
                                               <button id="btns" class="btn btn-success" @click="loadMap"
                                            v-if="btn==1 && snaken != '' || big4s != '' || to != '' || username != ''">Submit</button>
                                            </div>
                                            </div>
                                            </div>
                                            <div
                id="floating-panel"
                v-if="records.length > 0"
              >
                <a
                  v-on:click="newPoly()"
                  class="btn btn-success"
                >New Polygon</a>
              </div>
              <div v-if="sorted.length > 0" id="floating-panels">
                <download-excel
                  class="btn btn-success btn-sm"
                  :data="json_data"
                  :fields="json_fields"
                  name="filename.xls"
                >
                  Download Excel
                </download-excel>
              </div>
           <div id="map"></div>
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
import axios from 'axios'
import vSelect from 'vue-select'
var marker
var drawingManager
var all_overlays = []
export default {
  name: 'dashboard',
   components: {
    vSelect
  },
  data () {
    return {
      records: [],
      items: [],
      oMarker: [],
      stats: '',
      loading: false,
      from: '',
      to: '',
      snaken: [],
      snakes: [],
      count: '',
      tprd: '',
      big4: '',
      snakesall: '',
      big4data: [],
      username: '',
      useritem: [],
      users: [],
      user: [],
      options: [{
        text: 'Time Period',
        value: 'tprd'
        }, {
        text: 'Big4 Snakes',
        value: 'big4',
      },{
        text: 'All Snakes',
        value: 'snakesall'
      },
      {
        text: 'User',
        value: 'user'
      }],
      selected: [],
      vbig4: ["spectacled cobra","common krait","russell's viper","saw scaled viper"],
      big4s: [],
      sorted: [],
      btn: '',
          json_fields: {
        'Latitude': 'lat',
        'Longitude': 'lon',
        'Situation': 'sit',
        'SnakeName': 'snake',
        'User': 'user',
        'Date': 'createdAt'
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
    }
  },
  watch: {
  // from: function() {
  //   if(this.from !== '' && this.to != '')
  //         this.loadMap();
  // },
  // to: function() {
  //    if(this.from !== '' && this.to != '')
  //         this.loadMap();
  // },
  // big4s: function() {

  //   this.loadMap();

  // },
  // snaken: function () {
  //   if(this.snaken.length > 0)
  //   {
  //   this.loadMap();
  //   }

  // },
     selected: function () {
                var vm = this;
                var sel = this.selected;
                var i = 0;
                if (sel.indexOf('tprd') >= 0) {
                    vm.tprd = 'tprd';
                    i++;
                    vm.btn = 1;
                } else {
                    vm.tprd = '';
                    vm.from = '';
                    vm.to = '';
                }
                if (sel.indexOf('big4') >= 0) {
                    vm.big4 = 'big4';
                    i++;
                    vm.btn = 1;
                } else {
                    vm.big4 = '';
                    vm.big4s = [];
                }
                if (sel.indexOf('snakesall') >= 0) {
                    vm.snakesall= 'snakesall';
                    i++;
                    vm.btn = 1;
                } else {
                    vm.snakesall = '';
                    vm.snaken = [];
                }
                 if (sel.indexOf('user') >= 0) {
                    vm.user= 'user';
                    i++;
                    vm.btn = 1;
                } else {
                    vm.user = '';
                    vm.username = '';
                }
   },
  },
  mounted: function () {
     this.getList()
    this.loadMap()
    this.getUser()
  },
  methods: {
     getList () {
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/all/',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items = response.data.data
        var temp = []
        for (var i = 0; i < this.items.length; i++) {
          var ty = this.items[i].name
          temp.push(ty)
        }
        this.snakes = temp
      }).catch(e => {
        this.errors.push(e)
      })  
    },
       getUser () {
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/user/rescued/all/',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.useritem = response.data.data
        var temp = []
        for (var i = 0; i < this.useritem.length; i++) {
          var ty = this.useritem[i].username
          temp.push(ty)
        }
        this.users = temp
      }).catch(e => {
        this.errors.push(e)
      })
    },
    loadMap () {
      this.loading = true
      var mapCanvas = document.getElementById('map')
      var mapOptions = {
        // eslint-disable-next-line
        center: new google.maps.LatLng(10.8505, 76.2711),
        zoom: 7,
        // eslint-disable-next-line
        mapTypeId: google.maps.MapTypeId.HYBRID
      }
      var vm = this
      // eslint-disable-next-line
      vm.map = new google.maps.Map(mapCanvas, mapOptions)
     var temp = []
      for (var i = 0; i < this.items.length; i++) {
        for (var j = 0; j < this.big4s.length; j++) {
          if (this.items[i].name === this.big4s[j]) {
            var ty = this.items[i]._id
            temp.push(ty)
          }
        }
      }
      var temps = []
      for (var i = 0; i < this.items.length; i++) {
        for (var j = 0; j < this.snaken.length; j++) {
          if (this.items[i].name === this.snaken[j]) {
            var tys = this.items[i]._id
            temps.push(tys)
          }
        }
      }
      var data = {};
          if (this.from != '') data['from'] = this.from
          if (this.to != '') data['to'] = this.to
          if (this.big4s != '') data['big4'] = temp
          if (this.snaken != '') data['snakeid'] = temps
          if(this.username != '') data['username'] = this.username
        axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/location/find',
        method: 'POST',
        data: data,
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.records = response.data.data.records
         this.count = this.records.length
         if(this.count > 0){
        for (var i = 0; i < this.records.length; i++) {
          var id = this.records[i]._id
          var pic = 'https://sarpatnapi.leopardtechlabs.in/u/'+this.records[i].pic
          var lat = this.records[i].location[0]
          var lon = this.records[i].location[1]
          var sit = this.records[i].situation
          if(this.records[i].snake != undefined)
          var snake = this.records[i].snake.name
          if(this.records[i].user != undefined)
          var user = this.records[i].user.name
          var createdAt = this.records[i].createdAt
          // eslint-disable-next-line
          var latlngset = new google.maps.LatLng(lon, lat)
//           var iconBase = {
//     url: "https://sarpatnapi.leopardtechlabs.in/u/map_unavailable.png", // url
//     scaledSize: new google.maps.Size(10, 20), // scaled size
//     origin: new google.maps.Point(0,0), // origin
//     anchor: new google.maps.Point(0, 0) // anchor
// };

           var iconBase = 'http://maps.google.com/mapfiles/kml/pal4/icon49.png'
      
          marker = new google.maps.Marker({
            map: vm.map,
            position: latlngset,
            icon: iconBase
          })
          vm.oMarker[i] = {
            m: marker,
            c: id
          }
          var content = "<table  align='center'><tr><td colspan='9'><img src="+pic+" width='300px' height='auto'></td></tr><tr><td colspan='9'><b style='color:red;'>Reported by&nbsp;" + user + "</b><br><i>"+ createdAt +"</i></td></tr><tr><td colspan='9'><p style='color:#333333;size:12px;'>" + sit +
            "</p><p style='font-size:18px;color:#333333;font-weight:500'><b>" + snake +
            "</b></p></td></tr></table></body></html><button class='btn btn-danger btn-sm' onclick='doFunction(\""+ id + "\")'>Delete Record</button>"
          var infowindow = new google.maps.InfoWindow({
            maxWidth:200
          })
          google.maps.event.addListener(marker, 'click',
            (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content)
                infowindow.open(vm.map, marker)
              }

            })(marker, content, infowindow)
          )
          this.loading = false;
        }
          vm.polygonArray = [];
          drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ["polygon"]
            },
            polygonOptions: {
              editable: true
            }
          });
          drawingManager.setMap(vm.map);
          vm.stmap = 1;

          google.maps.event.addListener(
            drawingManager,
            "overlaycomplete",
            function(event) {
              all_overlays.push(event);
              event.overlay.set("editable", false);
              drawingManager.setMap(null);
            }
          );
          google.maps.event.addListener(
            drawingManager,
            "polygoncomplete",
            function(polygon) {
              for (var i = 0; i < polygon.getPath().getLength(); i++) {
                var poly = polygon
                  .getPath()
                  .getAt(i)
                  .toUrlValue(6);
                vm.polygonArray.push(poly);
              }
              vm.getDocs();
            }
          );
      }else{
        this.loading = false
      }
      }).catch(e => {
        this.loading = false;
        this.errors.push(e)
      })
    },
      newPoly: function() {
      this.polygonArray = [];
      this.sorted = []; /* added */
      for (var i = 0; i < all_overlays.length; i++) {
        all_overlays[i].overlay.setMap(null);
      }
      all_overlays = [];
      drawingManager.setMap(null);
      drawingManager.setMap(this.map);
    },
    getDocs: function() {
      var vm = this;
      var temp = [];
      let op = vm.polygonArray.map(e => {
        let temp = e.split(",");
        return { lat: Number(temp[0]), lng: Number(temp[1]) };
      });
      var temp = op;
      var Triangle = new google.maps.Polygon({ paths: temp });
      var tempr = [];
      var tempi = [];
      var res = [];
      for (var i = 0; i < vm.records.length; i++) {
        var lat = vm.records[i].location[1];
        var lng = vm.records[i].location[0];
        res[i] = google.maps.geometry.poly.containsLocation(
          new google.maps.LatLng(
            vm.records[i].location[1],
            vm.records[i].location[0]
          ),
          Triangle
        );
        if (res[i] === true) {
          if((vm.records[i].snake != undefined) && (vm.records[i].user != undefined)) {
          var tyu = {
          id : vm.records[i]._id,
          lat : vm.records[i].location[0],
          lon : vm.records[i].location[1],
          sit : vm.records[i].situation,
          snake : vm.records[i].snake.name,
          user : vm.records[i].user.name,
          createdAt: vm.records[i].createdAt
          };
          
          tempi.push(tyu);
           vm.sorted = tempi;
           vm.json_data = tempi;
          }
        }
      }
    },
  },
  
  created() {
    var vm=this;
    
        window.doFunction = function(id){  
      if (confirm("Are you sure?")) {
      axios({
        method: 'DELETE',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://sarpatnapi.leopardtechlabs.in/location/',
        data: {
          id: id,
        }
      }).then(response => {
        this.getList()
      }).catch(e => {
        alert('Successfully Deleted Reports')
        vm.loadMap()
        //window.location.reload();
      })
      }
        }
         
        }
}
</script>
<style scoped lang="scss">
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
#floating-panels {
  left: 70%;
  padding: 5px;
  position: absolute;
  top: 20px;
  z-index: 1;
  color: #fff;
}

#floating-panel {
  left: 50%;
  padding: 5px;
  position: absolute;
  top: 20px;
  z-index: 1;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/snakereports.vue